// Re-export from canonical location
export { default } from './shared/CaptureRateBadge';
